/* =========================================================================
   USMA — affichage de l'offre sur les lots.

   Ce fichier corrige deux defauts d'affichage de usma.js sans y toucher :
   il s'execute apres lui, donc ses ecritures font foi.

   1. Le nombre d'unites d'une variante etait lu avec /^\s*(\d+)/, soit un
      chiffre en TETE du nom. « 1 pain » donnait bien 1, mais « Lot de 3 »
      commence par une lettre : le lot etait compte pour une seule unite, et
      la ligne « Soit X l'unite — Y d'economie » ne s'affichait jamais.

   2. Le taux de remise etait rendu une seule fois par Liquid, pour la
      variante par defaut, et jamais recalcule. En passant au lot, la page
      affichait encore le taux du pain seul (-29 % au lieu de -25 %). Un
      pourcentage faux affiche a cote d'un prix barre est precisement ce que
      vise la directive Omnibus.

   Aucune unite n'est presentee comme « offerte » : le client paie les trois.
   Tous les montants sont calcules depuis les prix Shopify, jamais saisis.
   ========================================================================= */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) {
    return Array.prototype.slice.call((c || document).querySelectorAll(s));
  };

  function demarrer() {
    var form = $('form.usma-form');
    if (!form) return;

    var data = $('[data-usma-variants]');
    if (!data) return;

    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var unitaire = $('[data-usma-unitaire]');
    var badge    = $('.usma-produit__badge');

    var moneyFormat = window.usmaMoneyFormat || '{{amount}} €';

    function money(cents) {
      var n = (cents || 0) / 100;
      function avec(val, sep, dec, places) {
        var fixed = val.toFixed(places === 0 ? 0 : 2);
        var parts = fixed.split('.');
        var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
        return places === 0 ? whole : whole + dec + parts[1];
      }
      return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, nom) {
        switch (nom) {
          case 'amount':                      return avec(n, ',', '.', 2);
          case 'amount_no_decimals':          return avec(n, ',', '.', 0);
          case 'amount_with_comma_separator': return avec(n, '.', ',', 2);
          case 'amount_no_decimals_with_comma_separator':
                                              return avec(n, '.', ',', 0);
          case 'amount_with_space_separator': return avec(n, ' ', ',', 2);
          case 'amount_no_decimals_with_space_separator':
                                              return avec(n, ' ', ',', 0);
          default:                            return avec(n, ' ', ',', 2);
        }
      });
    }

    // Le chiffre est cherche partout dans le nom, plus seulement en tete.
    function unites(v) {
      var m = (v.options[0] || '').match(/(\d+)/);
      return m ? parseInt(m[1], 10) : 1;
    }

    // Prix de reference a l'unite : celui de la plus petite quantite
    // proposee. Il vient de Shopify, pas d'un prix barre saisi a la main.
    var refUnitaire = (function () {
      var best = null;
      variants.forEach(function (v) {
        var n = unites(v);
        if (best === null || n < best.n) best = { n: n, prix: v.price / n };
      });
      return best ? best.prix : null;
    })();

    function choisie() {
      var opts = $$('[data-usma-option]', form)
        .filter(function (i) { return i.checked; })
        .map(function (i) { return i.value; });
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    }

    function rafraichir() {
      var v = choisie();
      if (!v) return;

      if (unitaire && refUnitaire) {
        var n = unites(v);
        if (n > 1) {
          var plein = Math.round(refUnitaire * n);
          var gain  = plein - v.price;
          if (gain > 0) {
            var pct = Math.round((gain / plein) * 100);
            unitaire.hidden = false;
            unitaire.innerHTML = 'Soit <b>' + money(Math.round(v.price / n)) +
              ' l\'unité</b> — ' + money(gain) + ' d\'économie (' + pct + ' %)';
          }
        }
      }

      if (badge) {
        var enPromo = v.compare_at_price && v.compare_at_price > v.price;
        badge.hidden = !enPromo;
        if (enPromo) {
          var taux = Math.round(
            (v.compare_at_price - v.price) * 100 / v.compare_at_price);
          badge.textContent = '−' + taux + ' %';
        }
      }
    }

    // Le lot n'apparait comme une offre qu'une fois selectionne. Sans indice
    // sur le bouton, le visiteur n'a aucune raison d'aller voir : on annote
    // l'option qui fait economiser le plus, avec son taux reel.
    function annoter() {
      if (!refUnitaire || variants.length < 2) return;

      var meilleur = null;
      variants.forEach(function (v) {
        var n = unites(v);
        if (n < 2) return;
        var plein = Math.round(refUnitaire * n);
        var gain  = plein - v.price;
        if (gain > 0 && (meilleur === null || gain > meilleur.gain)) {
          meilleur = { gain: gain, plein: plein, valeur: v.options[0] };
        }
      });
      if (!meilleur) return;

      var taux = Math.round((meilleur.gain / meilleur.plein) * 100);
      $$('[data-usma-option]', form).forEach(function (i) {
        if (i.value !== meilleur.valeur) return;
        var lab = form.querySelector('label[for="' + i.id + '"]');
        if (lab && lab.textContent.indexOf('%') === -1) {
          lab.textContent = lab.textContent + '  ·  −' + taux + ' %';
        }
      });
    }

    // Enregistre apres usma.js : sur un meme evenement, le dernier ecrit.
    $$('[data-usma-option]', form).forEach(function (i) {
      i.addEventListener('change', rafraichir);
    });

    annoter();
    rafraichir();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
